import { Locale } from 'modules/i18n';

export const mainEndpointsTranslation = {
  [Locale.en]: {
    blockbookTooltip:
      'High-performance RESTful API to interact with indexed Bitcoin data.',
  },
};
